import React from "react";
import { Container } from "../../styles/search/map";

const Map = () => {
  return (
    <Container>
      <iframe
        title="map"
        loading="lazy"
        allowFullScreen
        src={`https://www.google.com/maps/embed/v1/view?key=AIzaSyDxt_0pndC4mR72g4IGedAn9uSAHiJjemI&zoom=18&center=6.465422, 3.406448`}
      ></iframe>
    </Container>
  );
};

export default Map;
